import { CSSProperties } from 'react';

import { getOptimizedImage } from 'pages/Settings/components/Tabs/CustomizationTab/components/CustomizationShell/compnents/ShellBackground/utils';
import { ISettingsContext } from 'settings/interfaces';

type ShellSettings = Pick<
  ISettingsContext['state']['settings'],
  | 'shellBgSkin'
  | 'shellSkinAccentColor'
  | 'shellSkinAdditionalColor'
  | 'shellSkinBackgroundColor'
  | 'shellSkinLogo'
>;

export interface IShellThemeStyle extends CSSProperties {
  '--ss-shell-accent-color': string;
  '--ss-shell-additional-color': string;
  '--ss-shell-additional-surface': string;
  '--ss-shell-background-color': string;
}

export interface IShellTheme {
  style: IShellThemeStyle;
  logoUrl: string | null;
}

const colorWithOpacity = (color: string, opacity: number): string => {
  const value = color.trim();
  const match = /^#([\da-f]{6})$/i.exec(value);

  if (!match) return value;

  const numericValue = Number.parseInt(match[1], 16);
  const red = numericValue >> 16;
  const green = (numericValue >> 8) & 255;
  const blue = numericValue & 255;

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};

const toCssUrl = (source: string): string =>
  `url("${source.replace(/"/g, '\\"')}")`;

export const createShellTheme = (settings: ShellSettings): IShellTheme => {
  const backgroundColor = settings.shellSkinBackgroundColor || '#232323';
  const backgroundSource = settings.shellBgSkin
    ? getOptimizedImage(settings.shellBgSkin)
    : null;

  return {
    style: {
      '--ss-shell-accent-color': settings.shellSkinAccentColor || '#7C62FF',
      '--ss-shell-additional-color':
        settings.shellSkinAdditionalColor || '#000000',
      '--ss-shell-additional-surface': colorWithOpacity(
        settings.shellSkinAdditionalColor || '#000000',
        0.48
      ),
      '--ss-shell-background-color': backgroundColor,
      backgroundColor,
      backgroundImage: backgroundSource
        ? `linear-gradient(${colorWithOpacity(
            backgroundColor,
            0.24
          )}, ${colorWithOpacity(backgroundColor, 0.24)}), ${toCssUrl(
            backgroundSource
          )}`
        : undefined,
    },
    logoUrl: settings.shellSkinLogo || null,
  };
};
